import classNames from "classnames";
import css from "./FieldLabel.module.scss";

interface FieldLabelProps {
    /** When set, renders as a `<label htmlFor>` bound to the control. */
    readonly htmlFor?: string;
    /** Sizes the label for a heading-sized value. */
    readonly large?: boolean;
    readonly className?: string;
    readonly children: React.ReactNode;
}

/** The shared uppercase field label. Pair it with its value via composition. */
export const FieldLabel: React.FC<FieldLabelProps> = ({
    htmlFor,
    large = false,
    className,
    children
}) => {
    const labelClassName = classNames(
        css["FieldLabel"],
        { [css["FieldLabel--large"]]: large },
        className
    );
    return htmlFor !== undefined ? (
        <label className={labelClassName} htmlFor={htmlFor}>
            {children}
        </label>
    ) : (
        <span className={labelClassName}>{children}</span>
    );
};
